import { useState, useEffect } from "react";
import { Box, Button, Menu, MenuItem } from "@mui/material";
import ExpandMoreIcon from "@mui/icons-material/ExpandMore";
import TherapyWeekCalendar from "./TherapyWeekCalendar";

// ---- shared palette (matches the rest of the app) -----------------------
const palette = {
  indigo: "#4B49AC",
  ink: "#1F2937",
  slate: "#6B7280",
  line: "#E6E9ED",
};

export default function CalendarPage({ userDetail }) {
  const [anchorEl, setAnchorEl] = useState(null);
  const [selectedBranch, setSelectedBranch] = useState(null);

  const branches = userDetail?.branches;
  const branchOpen = Boolean(anchorEl);

  useEffect(() => {
    if (branches?.length && !selectedBranch) {
      setSelectedBranch(branches[0]);
    }
  }, [branches, selectedBranch]);

  const handleClick = (event) => setAnchorEl(event.currentTarget);
  const handleClose = (branch) => {
    if (branch) setSelectedBranch(branch);
    setAnchorEl(null);
  };

  return (
    <Box>
      <Box sx={{ display: "flex", justifyContent: "flex-end", mb: 2 }}>
        <Button
          aria-controls={branchOpen ? "calendar-branch-menu" : undefined}
          aria-haspopup="true"
          aria-expanded={branchOpen ? "true" : undefined}
          onClick={handleClick}
          endIcon={<ExpandMoreIcon />}
          sx={{
            textTransform: "none",
            fontWeight: 600,
            fontSize: "13.5px",
            color: palette.ink,
            backgroundColor: "#fff",
            border: `1px solid ${palette.line}`,
            borderRadius: "10px",
            padding: "6px 14px",
            "&:hover": {
              backgroundColor: "#F5F4FB",
              borderColor: palette.indigo,
            },
          }}
        >
          {selectedBranch?.name || "Select branch"}
        </Button>

        <Menu
          id="calendar-branch-menu"
          anchorEl={anchorEl}
          open={branchOpen}
          onClose={() => handleClose(null)}
        >
          {branches?.map((branch) => (
            <MenuItem key={branch.id} onClick={() => handleClose(branch)}>
              {branch.name}
            </MenuItem>
          ))}
        </Menu>
      </Box>

      {selectedBranch && (
        <TherapyWeekCalendar branchId={selectedBranch.id} />
      )}
    </Box>
  );
}